import React from 'react';

const CitizenImportLegend = ({citizens}) => {
    const items = [
        {
            title: "Total de cidadões: ",
            value: citizens.length,
            border: true
        },
        {
            title: "OK: ",
            value: citizens.filter(d => !d.messages.length).length,
            color: "#008a0e"
        },
        {
            title: "Com problema: ",
            value: citizens.filter(d => d.messages.length).length,
            color: "#cb0000"
        }
    ];

    return (
        <div className={"grid-footer"}>
            <ul className="list-none flex gap-2 mb-0 bg-[#efefef] border border-t-0 border-[#efefef] p-1">
                {
                    items.map((i, key) => (
                        <li key={key}>
                            {i.title}
                            <span
                                style={{backgroundColor: i.color}}
                                className={["w-10 h-5 text-white font-bold text-xs inline-grid items-center justify-center rounded-sm", (i?.border ? "border border-[#555] !text-[#555]" : "")].join(" ")}
                            >
                                {i.value}
                            </span>
                        </li>
                    ))
                }
            </ul>
        </div>
    );
};

export default CitizenImportLegend;